module.exports = __webpack_public_path__ + "img/button.968f59ec.svg";